import React from 'react'
import { Icon } from '@iconify/react/dist/iconify.js'
import { useTranslation } from 'react-i18next'
import { Block, CRRender } from '../../../../crRender'
import "./style.css"
import { generator } from '@/utils/NumbersUtils'
const paggingScale = 5

const Pagging = ({ setTableFiller, previousPage, nextPage, gotoPage, canNextPage, paginationPages, pageIndex, isPagination, TotalRows, canPreviousPage }) => {

    const { i18n } = useTranslation()

    const hanldePrevPage = () => {
        if (!canPreviousPage) return
        setTableFiller(prev => ({ ...prev, page: prev.page - 1 }))
        previousPage()
    }
    const hanldeNextPage = () => {
        if (!canNextPage) return
        setTableFiller(prev => ({ ...prev, page: prev.page + 1 }))
        nextPage()
    }
    const hanldePage = (pageIndex) => {
        setTableFiller(prev => ({ ...prev, page: pageIndex }))
        gotoPage(pageIndex)
    }

    return (
        <Block isRender={isPagination && TotalRows} className={`table-footer ${i18n.language} `}>
            <Icon icon={`ic:round-chevron-${i18n.language == 'en' ? 'left' : 'right'}`} className={`paggination-arrow ${canPreviousPage ? '' : 'disabled'} `} onClick={hanldePrevPage} />
            <div className="page-cards-container">
                <div className={`${(pageIndex === 0) && 'selected-page'} page-num-card`} onClick={() => hanldePage(0)} >
                    1
                </div>
                {
                    paginationPages.slice(paginationPages.length == pageIndex ? pageIndex - (paggingScale - 2) : pageIndex - 1 > 0 ? pageIndex - 1 : 0, pageIndex + paggingScale).mapWithKey((p, index) => {
                        return (
                            <div key={p.key} className={`${pageIndex === p?.value - 1 && 'selected-page'} page-num-card`} onClick={() => hanldePage(p?.value - 1)} >
                                {p.value}
                            </div>
                        )
                    }
                    )
                }
                <CRRender isRender={paginationPages.length}>

                    <Block isRender={pageIndex <= paginationPages.length - (paggingScale + 2)}>
                        {'...'}
                    </Block>

                    <Block onClick={() => gotoPage(paginationPages.length)}
                        className={`${pageIndex == paginationPages.length && 'selected-page'} page-num-card`}
                        isRender={pageIndex <= paginationPages.length - (paggingScale + 1)} >
                        {paginationPages.slice(-1)[0]}
                    </Block>
                </CRRender>

            </div>
            <Icon icon={`ic:round-chevron-${i18n.language == 'en' ? 'right' : 'left'}`} className={`paggination-arrow ${canNextPage ? '' : 'disabled'} `} onClick={hanldeNextPage} />
        </Block>
    )
}

export default Pagging